import { useQuery } from "@tanstack/react-query";
import { InputSelect } from "../../atoms/Inputs/InputSelect";
import { SelectOption } from "../../../common/types/selectOption";
import { GET_MACHINERY_SELECT_OPTIONS } from "../../../common/query-keys";
import { request } from "../../../common/api";
import { ChangeEvent } from "react";

interface MachinerySelectProps {
  shipNo?: string;
  value?: string;
  onChange?: (e: ChangeEvent<HTMLSelectElement>) => void;
  errored?: boolean;
  erroredTxt?: string;
}
export const MachinerySelect = ({
  shipNo,
  value,
  errored,
  erroredTxt,
  onChange,
}: MachinerySelectProps) => {
  const { data: selectOptions } = useQuery<SelectOption[]>({
    queryKey: [GET_MACHINERY_SELECT_OPTIONS, shipNo],
    queryFn: async () => {
      if (!shipNo) {
        return [];
      }

      return await request<SelectOption[]>({
        method: "GET",
        url: `/equipment-info/machinery/select/options/${shipNo}`,
      });
    },
  });

  return (
    <InputSelect
      width={120}
      size="sm"
      placeholder="장비 선택"
      options={selectOptions}
      onChange={onChange}
      errored={errored}
      erroredTxt={erroredTxt}
      value={value}
    />
  );
};
